export default __webpack_public_path__ + "static/media/DesktopDrag.cdc0c75d.gif";